import { Box, Text } from 'mds-web-ui'
import { Link } from '@reach/router'
import React, { forwardRef } from 'react'
import styled from 'styled-components'
import { space } from 'styled-system'
import { GatsbyImage } from 'gatsby-plugin-image'

import { GridFlex } from '@utils/Containers'
import { fontSizes } from '@utils/Typography'

const SingleAppStyledLink = styled(Link)(
  {
    width: '100%',
    color: '#000',
    textDecoration: 'none',
    transition: 'background-color 100ms ease-out',
    borderRadius: 16,
    '&:hover': {
      backgroundColor: 'rgba(42, 69, 76, 0.08)'
    }
  },
  space
)

export const SingleAppLink = forwardRef(
  (
    {
      to,
      image,
      title,
      children,
      flexDirection = 'row',
      imageSize = 50,
      alt,
      grayscale = false,
      headingColor,
      textColor,
      ...props
    },
    ref
  ) => {
    return (
      <SingleAppStyledLink to={to}>
        <GridFlex
          gap={3}
          px={2}
          py={2}
          {...props}
          ref={ref}
          width="100%"
          alignItems="center"
          flexDirection={flexDirection}
          css={{
            filter: grayscale ? 'grayscale(1)' : 'initial'
          }}
        >
          <Box width={50} height={50}>
            <GatsbyImage
              image={image}
              width={imageSize}
              height={imageSize}
              alt={alt}
            />
          </Box>

          <GridFlex flex={1} flexDirection="column" gap={1}>
            {title ? (
              <Text
                as="h2"
                fontWeight="700"
                fontSize={fontSizes.body}
                m={0}
                color={headingColor}
              >
                {title}
              </Text>
            ) : null}
            <Text as="p" fontSize={fontSizes.body} color={textColor} m={0}>
              {children}
            </Text>
          </GridFlex>
        </GridFlex>
      </SingleAppStyledLink>
    )
  }
)
